import Phaser from 'phaser'

const API_BASE = (import.meta.env.VITE_SERVER_URL as string | undefined ?? 'wss://mean-bean-server.immoo360.workers.dev')
  .replace(/^wss:\/\//, 'https://')
  .replace(/^ws:\/\//, 'http://')

interface LeaderboardRow {
  id:           string
  display_name: string
  wins:         number
  losses:       number
  win_pct:      number
}

export class LeaderboardScene extends Phaser.Scene {
  constructor() { super({ key: 'LeaderboardScene' }) }

  async create(): Promise<void> {
    const W = this.scale.width
    const H = this.scale.height

    this.add.rectangle(W / 2, H / 2, W, H, 0x0a0a1a)

    this.add.text(W / 2, 44, 'LEADERBOARD', {
      fontFamily: 'monospace', fontSize: '30px', color: '#FFE566',
      stroke: '#000', strokeThickness: 3,
    }).setOrigin(0.5)

    // Back button
    const back = this.add.text(40, 44, '← BACK', {
      fontFamily: 'monospace', fontSize: '16px', color: '#888899',
    }).setOrigin(0, 0.5).setInteractive()
    back.on('pointerover', () => back.setColor('#ccccee'))
    back.on('pointerout',  () => back.setColor('#888899'))
    back.on('pointerdown', () => this.scene.start('LobbyScene'))

    this.input.keyboard!.on('keydown-ESC', () => this.scene.start('LobbyScene'))

    const loadText = this.add.text(W / 2, H / 2, 'Loading…', {
      fontFamily: 'monospace', fontSize: '16px', color: '#555577',
    }).setOrigin(0.5)

    try {
      const res  = await fetch(`${API_BASE}/leaderboard`)
      const data = await res.json() as { players: LeaderboardRow[] }
      loadText.destroy()

      if (data.players.length === 0) {
        this.add.text(W / 2, H / 2, 'Nenhuma partida registrada ainda.', {
          fontFamily: 'monospace', fontSize: '16px', color: '#555577',
        }).setOrigin(0.5)
        return
      }

      // Column headers
      const COL = [60, 110, 460, 560, 660, 760]
      const headerY = 100
      ;['#', 'PLAYER', 'WINS', 'LOSSES', 'WIN%', 'MATCHES'].forEach((h, i) => {
        this.add.text(COL[i], headerY, h, {
          fontFamily: 'monospace', fontSize: '12px', color: '#555577',
        })
      })

      // Divider
      this.add.rectangle(W / 2, headerY + 20, W - 80, 1, 0x333355)

      data.players.forEach((p, rank) => {
        const y     = headerY + 30 + rank * 26
        const color = rank === 0 ? '#FFE566' : rank < 3 ? '#aaaacc' : '#666688'
        const total = p.wins + p.losses
        ;[
          String(rank + 1),
          p.display_name.slice(0, 22),
          String(p.wins),
          String(p.losses),
          `${p.win_pct}%`,
          String(total),
        ].forEach((val, i) => {
          this.add.text(COL[i], y, val, {
            fontFamily: 'monospace', fontSize: '13px', color,
          })
        })
      })
    } catch {
      loadText.setText('Erro ao carregar leaderboard.')
    }
  }
}
